module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.addShopType == 1 || _vm.addShopType == 2 || _vm.addShopType == 3 || _vm.addShopType == 5 || _vm.addShopType == 6 || _vm.addShopType == 7) ? _c('div', {
    staticStyle: {
      "width": "96%",
      "margin": "auto"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.addGoodsForm,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 1 || _vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 1 || addShopType == 2 || addShopType == 3"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newType == 1 || _vm.newType == 4),
      expression: "newType == 1 || newType == 4"
    }],
    attrs: {
      "label": "店铺:",
      "prop": "goodBrand"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺",
      "disabled": _vm.disabledFour
    },
    on: {
      "change": _vm.handleDp
    },
    model: {
      value: (_vm.couponForm.bbId),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "bbId", $$v)
      },
      expression: "couponForm.bbId"
    }
  }, _vm._l((_vm.exhibitingBrands), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 2 || addShopType == 3"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品品牌"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.optionExhibitions,
      "filterable": "",
      "clearable": "",
      "disabled": _vm.disabledFour
    },
    on: {
      "change": _vm.handleSppp
    },
    model: {
      value: (_vm.addGoodsForm.goodBrand),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "goodBrand", $$v)
      },
      expression: "addGoodsForm.goodBrand"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品编码:",
      "prop": "goodModelCode"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入商品编码（10字以内）",
      "maxlength": 10,
      "debounce": 0,
      "trigger-on-focus": false,
      "disabled": _vm.disabledFour
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.addGoodsForm.goodModelCode),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "goodModelCode", $$v)
      },
      expression: "addGoodsForm.goodModelCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 1 || _vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 1 || addShopType == 2 || addShopType == 3"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入商品名称（20字以内）",
      "maxlength": "20",
      "disabled": _vm.disabledFour
    },
    model: {
      value: (_vm.addGoodsForm.title),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "title", $$v)
      },
      expression: "addGoodsForm.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "市场价:",
      "prop": "marketPrice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入市场价",
      "maxlength": "10",
      "disabled": _vm.disabledFour,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.addGoodsForm.marketPrice),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "marketPrice", $$v)
      },
      expression: "addGoodsForm.marketPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 2 || addShopType == 3"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单　　位:",
      "prop": "promotionPrice"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.unit),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "unit", $$v)
      },
      expression: "addGoodsForm.unit"
    }
  }, _vm._l((_vm.danwei), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 2),
      expression: "addShopType == 2"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "秒杀方式:",
      "prop": "seckillModeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择秒杀方式",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.seckillModeId),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "seckillModeId", $$v)
      },
      expression: "addGoodsForm.seckillModeId"
    }
  }, _vm._l((_vm.secondKillModeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "秒杀价:",
      "prop": "seckillPrice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入秒杀价",
      "maxlength": "10",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.addGoodsForm.seckillPrice),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "seckillPrice", $$v)
      },
      expression: "addGoodsForm.seckillPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.addGoodsForm.seckillModeId == 2) ? _c('el-form-item', {
    attrs: {
      "label": "秒杀定金:",
      "prop": "seckillDeposit"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入秒杀定金",
      "maxlength": "10",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.addGoodsForm.seckillDeposit),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "seckillDeposit", $$v)
      },
      expression: "addGoodsForm.seckillDeposit"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 3),
      expression: "addShopType == 3"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拼团方式:",
      "prop": "groupModeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择拼团方式",
      "filterable": "",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.groupModeId),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "groupModeId", $$v)
      },
      expression: "addGoodsForm.groupModeId"
    }
  }, _vm._l((_vm.groupTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团购价:",
      "prop": "groupPrice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入团购价",
      "maxlength": "10",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.addGoodsForm.groupPrice),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "groupPrice", $$v)
      },
      expression: "addGoodsForm.groupPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.addGoodsForm.groupModeId == 2) ? _c('el-form-item', {
    attrs: {
      "label": "团购定金:",
      "prop": "groupDeposit"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入团购定金",
      "maxlength": "10",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.addGoodsForm.groupDeposit),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "groupDeposit", $$v)
      },
      expression: "addGoodsForm.groupDeposit"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 2 || addShopType == 3"
    }]
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 2),
      expression: "addShopType == 2"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "秒杀数量:",
      "prop": "seckillStock"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择秒杀数量",
      "maxlength": "7",
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.addGoodsForm.seckillStock),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "seckillStock", $$v)
      },
      expression: "addGoodsForm.seckillStock"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 3),
      expression: "addShopType == 3"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "成团人数:",
      "prop": "groupNumber"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择成团人数",
      "maxlength": "7",
      "disabled": _vm.seeDisabled,
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.addGoodsForm.groupNumber),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "groupNumber", $$v)
      },
      expression: "addGoodsForm.groupNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "佣金比例:",
      "prop": "commissionRate"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入佣金比例",
      "maxlength": "6",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.addGoodsForm.commissionRate),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "commissionRate", $$v)
      },
      expression: "addGoodsForm.commissionRate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 1 || _vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 1 || addShopType == 2 || addShopType == 3"
    }]
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 1),
      expression: "addShopType == 1"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "促销价:",
      "prop": "promotionPrice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入促销价",
      "maxlength": "10",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.addGoodsForm.promotionPrice),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "promotionPrice", $$v)
      },
      expression: "addGoodsForm.promotionPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 2),
      expression: "addShopType == 2"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "秒杀时间:",
      "prop": "spikeTime"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "50%",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择日期",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.spikeDate),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "spikeDate", $$v)
      },
      expression: "addGoodsForm.spikeDate"
    }
  }, _vm._l((_vm.msriqiArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "26%"
    },
    attrs: {
      "placeholder": "选择时间",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '23:00'
      },
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.spikeTime),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "spikeTime", $$v)
      },
      expression: "addGoodsForm.spikeTime"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品优势:",
      "prop": "advantageOne"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.seeDisabled,
      "placeholder": "请输入商品优势（20字以内）",
      "maxlength": "20"
    },
    model: {
      value: (_vm.addGoodsForm.advantageOne),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "advantageOne", $$v)
      },
      expression: "addGoodsForm.advantageOne"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.addShopType == 2 || _vm.addShopType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "商品视频:"
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader proportionImg",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 1 || _vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 1 || addShopType == 2 || addShopType == 3"
    }],
    staticClass: "uploadActiveForm",
    attrs: {
      "label": "商品图片:",
      "prop": "goodsImgUrl"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader proportionImg",
    attrs: {
      "disabled": _vm.seeDisabled,
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.goodsImgUrl) ? _c('div', [_c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.goodsImgUrl
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.goodsImgUrl) ? _c('div', [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(" 建议尺寸：比例为1：1　支持的图片格式：jpg、png ")])]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 5 || _vm.addShopType == 6 || _vm.addShopType == 7),
      expression: "addShopType == 5 || addShopType == 6 || addShopType == 7"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "礼品数量:",
      "prop": "stock"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "请选择礼品数量",
      "maxlength": "7",
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        _vm.addGoodsForm.stock = $event.target.value
      }
    },
    model: {
      value: (_vm.addGoodsForm.stock),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "stock", $$v)
      },
      expression: "addGoodsForm.stock"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 5),
      expression: "addShopType == 5"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领取说明(选填)：",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "最多输入20个汉字",
      "maxlength": "20",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.receiveDesc),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "receiveDesc", $$v)
      },
      expression: "addGoodsForm.receiveDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 5),
      expression: "addShopType == 5"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "核销时间："
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择日期",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.writeOffDate),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "writeOffDate", $$v)
      },
      expression: "addGoodsForm.writeOffDate"
    }
  }, _vm._l((_vm.hxriqiArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择日期",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.addGoodsForm.writeOffEndDate),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "writeOffEndDate", $$v)
      },
      expression: "addGoodsForm.writeOffEndDate"
    }
  }, _vm._l((_vm.hxriqiArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 5 || _vm.addShopType == 6 || _vm.addShopType == 7),
      expression: "addShopType == 5 || addShopType == 6 || addShopType == 7"
    }]
  }, [_vm._l((_vm.journalArr), function(item, index) {
    return _c('div', {
      key: index
    }, [(_vm.journalArr.length >= 1) ? _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.seeDisabled),
        expression: "!seeDisabled"
      }],
      staticClass: "primarybtn"
    }, [_c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.shanchu(index)
        }
      }
    }, [_vm._v("　刪除　")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "礼品名称:"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "68%"
      },
      attrs: {
        "disabled": ""
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "礼品图片:"
      }
    }, [_c('div', {
      staticClass: "upPictures"
    }, [_c('div', {
      staticClass: "multigraph"
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.imgUrl
      }
    })], 1)])])], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.seeDisabled),
      expression: "!seeDisabled"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.journalArr.length <= 10),
      expression: "journalArr.length <= 10"
    }],
    staticClass: "primarybtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addJournal()
      }
    }
  }, [_vm._v("添加礼品")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "礼品名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "68%"
    },
    attrs: {
      "placeholder": "请输入礼品名称(20字以内)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.anwser),
      callback: function($$v) {
        _vm.anwser = $$v
      },
      expression: "anwser"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "礼品图片:"
    }
  }, [_c('div', {
    staticClass: "upPictures"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailImgUrlarr),
      expression: "detailImgUrlarr"
    }],
    staticClass: "multigraph"
  }, [_c('el-image', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.detailImgUrlarr
    }
  })], 1), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.detailImgUrlarr),
      expression: "!detailImgUrlarr"
    }],
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "action": "",
      "multiple": "",
      "before-upload": _vm.lpPucUpload,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus upBtn"
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "spPicWenan"
  }, [_c('p', [_vm._v("1.支持JPG,PNG格式图片，单张最大支持5MB；")]), _vm._v(" "), _c('p', [_vm._v("2.礼品是否添加成功，以礼品列表内容为准。")])])])], 1)], 1)], 2), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 6),
      expression: "addShopType == 6"
    }],
    attrs: {
      "label": "打卡店铺:"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleXzdp()
      }
    }
  }, [_vm._v("选择店铺")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("已选择 " + _vm._s(_vm.alreadyChoose.length) + " 个店铺：")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alreadyChoose.length > 0),
      expression: "alreadyChoose.length>0"
    }],
    staticClass: "dakadianpu"
  }, _vm._l((_vm.alreadyChoose), function(id) {
    return _c('p', {
      key: id
    }, [_vm._v(_vm._s(_vm.getdianpuname(id)))])
  }), 0)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 7),
      expression: "addShopType == 7"
    }],
    attrs: {
      "label": "连单数量:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入需连单数",
      "maxlength": "10",
      "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
    },
    model: {
      value: (_vm.liandanshul),
      callback: function($$v) {
        _vm.liandanshul = $$v
      },
      expression: "liandanshul"
    }
  }), _vm._v(" 单\r\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 7),
      expression: "addShopType == 7"
    }],
    attrs: {
      "label": "每单金额:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入每单最低消费金额",
      "maxlength": "10",
      "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
    },
    model: {
      value: (_vm.meidanjine),
      callback: function($$v) {
        _vm.meidanjine = $$v
      },
      expression: "meidanjine"
    }
  }), _vm._v(" 元\r\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 7),
      expression: "addShopType == 7"
    }]
  }, [_c('p', {
    staticStyle: {
      "width": "78%",
      "height": "20px",
      "line-height": "20px"
    }
  }, [_vm._v("\r\n          温馨提示：联单规则是指用户在整个活动有效期限内，在多个活动商家店铺进行连续消费，且消费金额及订单数达到规定门槛，即可兑换相应礼品。\r\n        ")])]), _vm._v(" "), (_vm.addShopType == 6 || _vm.addShopType == 7) ? _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "规则说明:"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 6),
      expression: "addShopType == 6"
    }],
    attrs: {
      "type": "textarea",
      "rows": 8,
      "maxlength": "1000"
    },
    model: {
      value: (_vm.dddklGzsm),
      callback: function($$v) {
        _vm.dddklGzsm = $$v
      },
      expression: "dddklGzsm"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 7),
      expression: "addShopType == 7"
    }],
    attrs: {
      "type": "textarea",
      "rows": 8,
      "maxlength": "1000"
    },
    model: {
      value: (_vm.ldlGzsm),
      callback: function($$v) {
        _vm.ldlGzsm = $$v
      },
      expression: "ldlGzsm"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addShopType !== 4) ? _c('div', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShopType == 1 || _vm.addShopType == 2 || _vm.addShopType == 3),
      expression: "addShopType == 1 || addShopType == 2 || addShopType == 3"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "商品简介:"
    }
  }, [_c('wjEditor', {
    attrs: {
      "desc": _vm.addGoodsForm.productProfile
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1), _vm._v(" "), (_vm.addShopType == 2 || _vm.addShopType == 3) ? _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "活动说明:"
    }
  }, [_c('wjEditor', {
    attrs: {
      "desc": _vm.addGoodsForm.activityDesc
    },
    on: {
      "change": _vm.contentChangetWO
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px 0"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelActiveForm('addGoodsForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.seeDisabled ? '返回' : '取消'))]), _vm._v(" "), (_vm.seeSaveBtn == false) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.saveAddGoods_late('addGoodsForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        return _vm.resetOne('addGoodsForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addShopType == 4) ? _c('div', {
    staticStyle: {
      "width": "96%",
      "margin": "auto"
    }
  }, [_c('h3', [_vm._v("优惠券信息")]), _vm._v(" "), _c('el-form', {
    ref: "couponForm",
    attrs: {
      "model": _vm.couponForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newType == 1 || _vm.newType == 4),
      expression: "newType == 1 || newType == 4"
    }],
    attrs: {
      "label": "适用店铺:",
      "prop": "brandName"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    model: {
      value: (_vm.couponForm.bbId),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "bbId", $$v)
      },
      expression: "couponForm.bbId"
    }
  }, _vm._l((_vm.exhibitingBrands), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "disabled": _vm.seeDisabled,
      "placeholder": "请输入优惠券名称（10字以内）",
      "maxlength": "10"
    },
    model: {
      value: (_vm.couponForm.name),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "name", $$v)
      },
      expression: "couponForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "售价:",
      "prop": "price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入优惠券的售价",
      "maxlength": "10",
      "disabled": _vm.seeDis || _vm.IsInterview == true,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.couponForm.price),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "price", $$v)
      },
      expression: "couponForm.price"
    }
  }), _vm._v("  元\r\n          "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "disabled": _vm.seeDisabled
    },
    on: {
      "change": function($event) {
        return _vm.mianfei()
      }
    },
    model: {
      value: (_vm.IsInterview),
      callback: function($$v) {
        _vm.IsInterview = $$v
      },
      expression: "IsInterview"
    }
  }, [_vm._v("免费")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label": "优惠券面值:",
      "prop": "faceValue"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入优惠券面值",
      "maxlength": "7",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.couponForm.faceValue),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "faceValue", $$v)
      },
      expression: "couponForm.faceValue"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("元")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发放数量:",
      "prop": "number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入优惠券的数量",
      "maxlength": "7",
      "disabled": _vm.seeDisabled,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.couponForm.number),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "number", $$v)
      },
      expression: "couponForm.number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "使用门槛:",
      "prop": "hasThreshold"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.hasThreshold),
      callback: function($$v) {
        _vm.hasThreshold = $$v
      },
      expression: "hasThreshold"
    }
  }, [_vm._v(" 无门槛 ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": _vm.seeDisabled
    },
    model: {
      value: (_vm.hasThreshold),
      callback: function($$v) {
        _vm.hasThreshold = $$v
      },
      expression: "hasThreshold"
    }
  }, [_vm._v("\r\n            满  \r\n            "), _c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入金额",
      "disabled": _vm.couponForm.disableThreshold,
      "maxlength": "7",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.couponForm.useThreshold),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "useThreshold", $$v)
      },
      expression: "couponForm.useThreshold"
    }
  }), _vm._v("\r\n              元  可使用\r\n            ")], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "每人可领取:",
      "prop": "receiveNumber"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "disabled": _vm.seeDisabled,
      "maxlength": "7",
      "placeholder": "请输入",
      "onkeyup": "value=value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.couponForm.receiveNumber),
      callback: function($$v) {
        _vm.$set(_vm.couponForm, "receiveNumber", $$v)
      },
      expression: "couponForm.receiveNumber"
    }
  }), _vm._v("\r\n            张  \r\n          ")], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "特殊说明："
    }
  }, [_c('wjEditor', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "desc": _vm.couponForm.specialInstructions
    },
    on: {
      "change": _vm.contentChangeThree
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px 0"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('couponForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.seeDisabled ? '返回' : '取消'))]), _vm._v(" "), (_vm.seeSaveBtn == false) ? _c('el-button', {
    staticClass: "search_btn",
    attrs: {
      "type": "primary",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.saveCouponForm('couponForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        return _vm.resetTwo('couponForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addShopType == 8) ? _c('div', [_c('div', {
    staticClass: "displayFlex"
  }, [_c('el-card', {
    staticClass: "box-card card1",
    style: ('height:' + _vm.scrollbarHeight)
  }, [_c('el-tree', {
    ref: "rightsTree",
    staticClass: "lineheighttree",
    attrs: {
      "data": _vm.oneData,
      "props": _vm.defaultProps,
      "node-key": "id",
      "highlight-current": "",
      "default-checked-keys": _vm.defaultCheckedKeys
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card card2",
    style: ('height:' + _vm.scrollbarHeight)
  }, [_c('div', {
    staticStyle: {
      "padding": "0px 20px"
    }
  }, [_c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "60%"
    },
    attrs: {
      "label": "商品名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    },
    attrs: {
      "placeholder": "请输入商品名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.EnterpriseName),
      callback: function($$v) {
        _vm.EnterpriseName = $$v
      },
      expression: "EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "invoice_tab tabler_inner_container",
    staticStyle: {
      "height": "auto",
      "max-height": "500px"
    },
    attrs: {
      "data": _vm.brandList,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.goodsname
          }
        }, [_vm._v(_vm._s(scope.row.goodsname))])]
      }
    }], null, false, 2106333156)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodstypename))]
      }
    }], null, false, 2347083602)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价格(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.price))]
      }
    }], null, false, 3949003760)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "order_toolbar_footer",
    staticStyle: {
      "margin-top": "15px",
      "float": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexFive,
      "page-size": 10,
      "total": _vm.totalRowsCountFive
    },
    on: {
      "current-change": _vm.handleTabFive
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "15px auto",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelActiveForm('addGoodsForm')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addTjsp()
      }
    }
  }, [_vm._v("保存")])], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择店铺",
      "visible": _vm.dialogVisible,
      "width": "680px",
      "height": "422px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "78px",
      "background": "#F56C6C"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.getSortList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "shut"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('p', [_vm._v("店铺列表")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('p', [_vm._v("选择店铺")])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "shuttle"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "TLeft",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, _vm._l((_vm.TData), function(val, index) {
    return _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (val.name.indexOf(_vm.tempkey) > -1),
        expression: "val.name.indexOf(tempkey)>-1"
      }],
      key: index,
      on: {
        "click": function($event) {
          return _vm.checkImg(val, index)
        }
      }
    }, [(_vm.alreadyChooseTemp.indexOf(val.id) < 0) ? _c('img', {
      staticClass: "left_img",
      attrs: {
        "src": _vm.src1
      }
    }) : _c('img', {
      staticClass: "left_img",
      attrs: {
        "src": _vm.src2
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(val.name))])])
  }), 0), _vm._v(" "), _c('el-col', {
    staticClass: "border_r",
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.TData), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.alreadyChooseTemp.indexOf(item.id) >= 0),
        expression: "alreadyChooseTemp.indexOf(item.id) >= 0"
      }],
      key: index,
      staticClass: "TRight"
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('img', {
      staticClass: "chahao",
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.canCheck(item, index)
        }
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.confirmSetRole()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d2cdb61!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/addActiviteForm.vue
// module id = 1661
// module chunks = 3